import React, { Component } from "react";
import Dropdown from "components/Dropdown";
import TypeLineIcon from "assets/Chart/type-line.svg";
import TypeScatterIcon from "assets/Chart/type-scatter.svg";
import TypeLineScatterIcon from "assets/Chart/type-scatter+line.svg";
import { CHART_EDIT_TAGS_TABLE_STRINGS } from "constants/constantStrings";

const TAG_TYPES = [
  {
    label: CHART_EDIT_TAGS_TABLE_STRINGS.tagTypeLine,
    type: "lines",
    icon: TypeLineIcon
  },
  {
    label: CHART_EDIT_TAGS_TABLE_STRINGS.tagTypeScatter,
    type: "markers",
    icon: TypeScatterIcon
  },
  {
    label: CHART_EDIT_TAGS_TABLE_STRINGS.tagTypeLineScatter,
    type: "lines+markers",
    icon: TypeLineScatterIcon
  }
];

export default class ChartTagTypeRenderer extends Component {
  changeHandler = value => {
    if (value) {
      const Type = value.type;
      const { rowIndex, data } = this.props.node;
      this.props.node.setData({ ...data, Type, isEdited: true });
      this.props.context.updateChartView(rowIndex);
    }
  };

  getTypeIcon = tagType => {
    const item = TAG_TYPES.find(option => option.label === tagType);
    return item?.icon;
  };

  inputAdornment = value => {
    return {
      startAdornment: (
        <img
          className="chart-edit-tag-input-icon"
          src={this.getTypeIcon(value)}
          height="24px"
          width="24px"
          style={{ marginLeft: "10px" }}
          alt={value}
        />
      )
    };
  };

  getValue = () => {
    const { Type } = this.props.node.data;
    return TAG_TYPES.find(tagType => tagType.type === Type);
  };

  renderOption = option => {
    return (
      <>
        <img className="chart-edit-tag-input-icon" src={option.icon} height="16px" width="16px" alt={option.type} />
        {option.label}
      </>
    );
  };

  render() {
    return (
      <Dropdown
        value={this.getValue()}
        options={TAG_TYPES}
        getOptionLabel={option => option.label}
        getOptionSelected={(option, value) => option.type === value.type}
        onChange={this.changeHandler}
        renderOption={this.renderOption}
        inputAdornment={this.inputAdornment}
        customClass="chart-tag-drop-down"
      />
    );
  }
}
